"use client";

import { memo } from "react";
import { cn } from "@/lib/utils";
import Avatar from "./avatar";
import { AvatarProps } from "./avatar";
import { Typography } from "./typography";

export type UserMetaProps = {
  name?: string;
  position?: string;
} & React.ComponentProps<"div"> &
  AvatarProps;

const UserMeta = ({
  url,
  fallbackName,
  name,
  position,
  className,
}: UserMetaProps) => {
  const hasUserInfo = Boolean(name || position);
  const hasAvatar = Boolean(url || name || fallbackName);
  return (
    <div className={cn("flex items-center space-x-2", className)}>
      {hasAvatar && (
        <Avatar url={url} fallbackName={fallbackName ?? name}></Avatar>
      )}
      {hasUserInfo && (
        <div className="grid grid-cols-1 place-content-start text-[13px] leading-[100%] text-semantic-text-primary">
          {!!name && (
            <h4>
              <strong className="font-bold">{name}</strong>
            </h4>
          )}
          {!!position && <div>{position}</div>}
        </div>
      )}
    </div>
  );
};

export default memo(UserMeta);
